import React from 'react';
import { Image } from 'react-bootstrap';

function ImageX(props) {
  return <Image className="py-5 pt-10" {...props} />;
}

export default ImageX;
